export const environment = {
  apiUrl: 'https://appapi.testsms.ir/',
  resellerServerUrl: 'https://reseller-api.testsms.ir/',
  appVersion: '9.7.2',
  releaseDate: '1389-1405',
  production: false,
  isLocal: true,
  envName: 'test',
  martinBaseUrl: 'https://map.sms.ir',

  cookieDomain: '.testsms.ir',
  cookieSecure: true,
  cookieSameSite: 'Lax',
};
